import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class SpecialNewsService {
    constructor() {
        this.httpClient = new HttpClient()
    }


    getSpecialNewsList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `special-news`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    addNewItem(title, link) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `special-news`,
                {
                    title,
                    link
                }
            ).then(resolve).catch(reject)
        })
    }

    getSpecialNewsDetail(id) {
        const globalInfoReq = this.httpClient.get(
            `special-news/${id}/information`
        );

        const publishedReq = this.httpClient.get(
            `special-news/${id}/published`
        )

        const requests = [globalInfoReq, publishedReq]

        return new Promise((resolve, reject) => {
            axios.all(requests)
                .then(axios.spread((globalInfo, published) => {
                    resolve({
                        globalInfo, published
                    })
                })).catch(reject)
        })
    }

    updateGlobalInfo(id, title, link) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `special-news/${id}/information`,
                {
                    title, link
                }
            ).then(resolve).catch(reject)
        })
    }

    updatePublishedState(id, published) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `special-news/${id}/published`,
                {},
                {
                    published
                }
            ).then(resolve).catch(reject)
        })
    }
}